/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
// import omitBy from 'lodash/omitBy'

// material UI
import Grid from '@material-ui/core/Grid'

// material ui icon
// import GetAppIcon from '@material-ui/icons/GetApp'

// my components
// import UserComponentName from 'components/molecules/UserComponentName'
import LoginContainer from 'containers/LoginContainer'

// libraries
// import { isArray } from 'lib/detectType'

const styles = theme => ({
  root: {
    minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight + 225}px)`
  }
})
export const useProps = {}
/**
 * (작성된 설명이 없습니다.)
 */
const LoginPage = ({ classes, proxy, ...props }) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className={classes.root}
    >
      <Grid item>
        <LoginContainer />
      </Grid>
    </Grid>
  )
}

LoginPage.defaultProps = setDefaultProps(useProps)
LoginPage.propTypes = setPropTypes(useProps)
export default withStyles(styles)(LoginPage)
